/**
 * Makes the product-page star rating scroll down to the Judge.me review widget.
 *
 * The markup is a plain anchor to #judgeme_product_reviews, so this only upgrades the
 * behaviour: a native jump would land under the sticky header and give no indication
 * that the page moved. The listener is delegated from the document so it keeps working
 * for ratings re-rendered by the Section Rendering API on variant change.
 */
(function () {
const REVIEW_TARGETS = [
  '#judgeme_product_reviews',
  '.jdgm-rev-widg',
  '.jdgm-widget',
];

function findReviewWidget() {
  for (const selector of REVIEW_TARGETS) {
    const el = document.querySelector(selector);
    // Judge.me leaves empty placeholder nodes around; only take one that has rendered.
    if (el && el.offsetHeight > 0) return el;
  }
  return null;
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-reviews-jump]');
  if (!trigger) return;

  const widget = findReviewWidget();
  // No widget on this page: leave the browser to handle the href rather than
  // swallowing the click and doing nothing.
  if (!widget) return;

  event.preventDefault();

  // scrollIntoView honours the widget's scroll-margin-top, which is set in CSS from the
  // theme's own --sticky-header-height. Keeping the offset in CSS means a plain anchor
  // jump lands in the right place too, so this stays correct even if the script fails.
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const startY = window.scrollY;
  widget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

  // Some environments silently ignore smooth scrolling. If nothing has moved shortly
  // after, jump instantly instead - landing without animation beats not landing at all.
  if (!reduceMotion) {
    setTimeout(() => {
      if (Math.abs(window.scrollY - startY) < 4) {
        widget.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
    }, 400);
  }

  // Send keyboard and screen-reader users to the widget too, without letting focus
  // trigger a second competing scroll.
  widget.setAttribute('tabindex', '-1');
  widget.focus({ preventScroll: true });
});
// IIFE-wrapped so no name reaches global scope and collides with an app script.
})();
